(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("tcc-fds"), require("react"));
	else if(typeof define === 'function' && define.amd)
		define("tcc-plugin-ui", ["tcc-fds", "react"], factory);
	else if(typeof exports === 'object')
		exports["tcc-plugin-ui"] = factory(require("tcc-fds"), require("react"));
	else
		root["tcc-plugin-ui"] = factory(root["tcc-fds"], root["react"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__996__, __WEBPACK_EXTERNAL_MODULE__155__) => {
return 